module.exports = __webpack_public_path__ + "static/img/left-bottom-row-4.b97f9890.png";